import { Producto } from './producto.model';
import { Cliente } from './cliente.model';
export class UnidadMedida {
                public codUnidad: number;
                public codEmpresa: number;
                public cantidad: number;
                public codUnidadErp: string;
                public nombreUnidad: string;
                constructor() { }
    }